/**
 * 语音、搜索
 */
import React, { useCallback, useEffect } from 'react'
import { observer } from 'mobx-react'
import { decorationMobx, voiceServiceMobx } from '@mobxStore'
import { classNames } from '@dt/fe-utils'
import { getPlatform, modalLayer, useHistoryNew } from '@utils'
import { wxConfigG } from 'controllers/third'
import Recorder from 'controllers/record'
import { Icon } from '@cps'
import { VoiceModal } from '../../modal'
import './index.scss'

type TSupportType = 'search' | 'voice';

interface IProps {
}

const CartSupportBar: React.FC<IProps> = ({ }) => {
  const history = useHistoryNew()
  const { mealDecorates: decoratesInfo } = decorationMobx
  const { tt: targetType = '' } = history.location.state || {} as any
  const { isWeixinMiniProgram, isAndroid } = getPlatform()

  const supportArr = [decoratesInfo.isOpenSearch && 'search', voiceServiceMobx.isVoiceSearchEnable && 'voice'].filter(Boolean) as TSupportType[]

  useEffect(() => {
    if (targetType === 'voice') {
      handleVoiceBtnClick()
    }
  }, [targetType])

  const handleVoiceBtnClick = () => {
    // 解决安卓微信小程序请求js-sdk报签名无效的错误问题
    if (isAndroid && isWeixinMiniProgram) {
      wxConfigG.init()
    }

    if (wxConfigG.isInited()) {
      wx.startRecord({
        success: function (res) {
          wx.stopRecord({
            success: (res) => {}
          })
          showVoiceModal()
        },
        fail: function (err) {
          console.log(err, 'err')
        }
      })
    } else {
      Recorder.get((rec) => {
        showVoiceModal()
      })
    }
  }

  const showVoiceModal = () => {
    modalLayer(VoiceModal, {
      showSearch: () => {
        history.replace({})
        handleSearchBtnClick()
      }
    }).then(() => {}).catch(() => {
    }).finally(() => {
      history.replace({})
    })
  }

  const handleSearchBtnClick = () => {
    history.push('/search')
  }

  const getSupportInfo = useCallback((type: TSupportType) => {
    let icon = ''
    let func = null
    switch (type) {
      case 'search':
        icon = 'search'
        func = handleSearchBtnClick
        break
      case 'voice':
        icon = 'vioce_microphone'
        func = handleVoiceBtnClick
        break
    }

    return {
      icon,
      func
    }
  }, [])

  return (
    <>
      <div className='cart-box-supports'>
        {
          supportArr.map(item => {
            const { icon, func } = getSupportInfo(item)
            return (
              <div className={classNames('cart-box-support', { single: supportArr.length === 1 })} key={item} onClick={func}>
                <Icon name={icon} />
              </div>
            )
          })
        }
      </div>
    </>
  )
}

export default observer(CartSupportBar)
